module.exports = __webpack_public_path__ + "/images/shop/footer-reduced/tec_alliance.jpg";